import React, { Component } from 'react'
import VimeoPlayer from 'react-player/lib/players/Vimeo'
import PlayIcon from 'mdi-react/PlayIcon'
import interact from 'interactjs'

import utils, { isTouchDevice } from '../utils'

class Item extends Component {
    constructor(props) {
        super(props);
        const { url, isBigger, isRect } = props;
        utils(url, isRect ? 900 : isBigger ? 800 : 500).then(urls => {
            if (!this.unmount)
                this.setState({ ...urls, loaded: true })
        })
    }

    state = {
        loaded: false,
        videoHoverRed: false,
        videoLoaded: true,
        resizeUrl: '',
        originalUrl: '',
        biggerLoaded: false,
        scale: 1,
        position: { x: 0, y: 0 }
    };

    item = React.createRef()

    componentWillUnmount() {
        if (this.asking) {
            this.asking.src = ""
            this.asking.onload = null
        }
        this.unmount = true
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.activeN === this.props.n) {
            this.setState({ videoHoverRed: false })
            if (this.props.open || nextProps.open) {
                if (isTouchDevice() && this.item.current ) {
                    this.int = interact(this.item.current)
                        .gesturable({
                            onstart: () => this.scale = this.state.scale - 1,
                            onmove: ({scale}) => this.setState(state => ({scale: this.calcScale(scale + this.scale)}))
                        }).draggable({
                            onmove: ({dx, dy}) => {
                                this.setState(({position: {x, y}}) => ({position: this.calcPosition(x + dx, y + dy)}))
                            }
                        })
                }
            }
        } else if (this.props.activeN === this.props.n && nextProps.activeN !== this.props.n) {
            if (this.asking && this.asking.src) {
                this.asking.onload = null
                this.asking.src = ""
            }
            this.setState({ scale: 1, position: { x: 0, y: 0 }, biggerLoaded: false })
            if (this.int && this.int.unset) {
                this.int.unset()
            }
        }
        if (!nextProps.open && this.props.open) {
            this.setState({biggerLoaded: false, scale: 1, position: { x: 0, y: 0 } })
        }
    }

    calcScale = scale => {
        if (scale > 5) {
            return 5
        } else if (scale < 1) {
            return 1
        }
        return scale
    }

    calcPosition = (x, y) => {
        return { x, y }
    }

    render() {
        const {loaded, videoHoverRed, biggerLoaded} = this.state;
        const {url, x, y, size, name, open, onOpen, n, isRect, video, activeN, closing, translateX} = this.props;
        const { resizeUrl, originalUrl, scale, position } = this.state
        const classN = ["item"];
        let style = {
            top: `${y}px`,
            left: `${x}px`,
            width: `${size}px`,
            height: `${isRect ? isRect : size}px`,
        };
        if (open) {
            classN.push("open");
            style = {
                ...style,
                backgroundSize: 'contain',
                height: `${window.innerHeight}px`
            };
        } else if (closing && activeN !== n) {
            classN.push("closing")
        } else if (closing && activeN === n) {
            classN.push("animate_close")
        }
        let loaderStyle = {
            ...style,
            backgroundColor: 'rgb(255, 255, 255)'
        };
        if (open) {
            const mid = x + document.documentElement.clientWidth / 2
            const adjust = document.documentElement.clientWidth * 2
            const visible = translateX > mid - adjust && translateX < mid + adjust
            if (!visible) {
                return null
            } else if (visible && !biggerLoaded && (!this.asking || !this.asking.onload)) {
                this.asking = new Image()
                this.asking.onload = () => {
                    setTimeout(() => {
                        this.asking.src = ""
                        this.asking.onload = null
                        this.setState({biggerLoaded: true})
                    }, 100)
                }
                this.asking.src = this.state.originalUrl
            }
        }
        if (video && open && activeN === n && loaded) {
            const videoStyle = {
                ...style,
                display: 'block',
            }
            return (
                <>
                    <div className={classN.join(' ')} style={videoStyle} data-name={name}>
                        <VimeoPlayer url={video} width={document.documentElement.clientWidth} height={window.innerHeight} style={{margin: 'auto', backgroundColor: 'black'}} onStart={this.test} playing loop />
                    </div>
                </>
            )
        } else if (!loaded) {
            style = {
                ...style,
                opacity: 0,
            };
            loaderStyle = {
                ...loaderStyle
            }
            return (
                <>
                    <div key={video ? url : undefined} className={classN.join(' ')} onClickCapture={!open ? () => onOpen(n) : undefined} style={style} />
                    <div className={classN.join(' ')} style={loaderStyle} />
                </>
            )
        } else {
            style = {
                ...style,
                backgroundImage: `url(${open && biggerLoaded ? originalUrl : resizeUrl})`,
            }
            if (open && activeN === n) {
                style = {
                    ...style,
                    backgroundSize: scale !== 1 ? `${scale * 100}%` : 'contain',
                    backgroundPosition: scale !== 1 ? `calc(50% + ${position.x}px) calc(50% + ${position.y}px)` : 'center'
                }
            }
            if (video) {
                style = {
                    ...style,
                    textAlign: 'center',
                }
                return (
                    <div
                        no-touch="true"
                        key={url}
                        ref={this.item}
                        className={classN.join(' ')}
                        onClickCapture={!open ? () => {
                            this.setState({ videoHoverRed: false, videoLoaded: false })
                            onOpen(n)
                        } : undefined}
                        style={style}
                        data-name={name}
                        onPointerEnter={() => this.setState({ videoHoverRed: true })}
                        onPointerOut={() => this.setState({ videoHoverRed: false })}
                    >
                        {!videoHoverRed &&
                            <PlayIcon style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translateX(-50%) translateY(-50%)' }} color='white' size={size / 3} />
                        }
                        <div className="image_title">{ name.split('\\n').map((t, i) => <div key={t} className={i > 0 ? 'sub' : ''}>{t}</div>) }</div>
                    </div>
                )
            } else {
                return (
                    <div ref={this.item} className={classN.join(' ')} onClickCapture={!open ? () => onOpen(n) : undefined} style={style}>
                        <div className="image_title">{ name.split('\\n').map((t, i) => <div key={t} className={i > 0 ? 'sub' : ''}>{t}</div>) }</div>
                    </div>
                )
            }
        }
    }
}

export default Item
